import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  UseGetVendorsQuoteStatusesBody,
  UseGetVendorsQuoteStatusesQueryKey,
  VendorQuoteStatusesResponseData,
} from './types';
import { getUseGetVendorsQuoteStatusQueryKey } from './utils';

export const useGetVendorQuoteStatuses: QueryFunction<
  VendorQuoteStatusesResponseData,
  [UseGetVendorsQuoteStatusesBody],
  UseGetVendorsQuoteStatusesQueryKey
> = (requestBody, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getUseGetVendorsQuoteStatusQueryKey(requestBody);
  return useQuery<
    VendorQuoteStatusesResponseData,
    unknown,
    VendorQuoteStatusesResponseData,
    UseGetVendorsQuoteStatusesQueryKey
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/vendors/quote_statuses`, {
        init: {
          method: 'POST',
          body: requestBody,
          signal,
        },
      });
    },
  });
};
